import { IconV3, IconV3Props, RpiLabelText } from "@rpi/openapi-core";
import { getRoutePath, NavRouteLink, RoutePathsKeys } from "../../hooks/useNavigateRoute";
import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";

const useStyles = createStyles(() => ({
  navButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: tokens.spacing[3],
    gap: tokens.spacing[2],
    width: 48,
    height: 48,
    borderRadius: tokens.radius.sm,
    textDecoration: "none",
    flexDirection: "row",
    color: tokens.color.semantic.text.bold,
    backgroundColor: "transparent",
    transition: "all 0.2s ease",
    overflow: "hidden",
    "&:active": {
      color: tokens.color.semantic.text.linkActive,
    },
    "&:hover": {
      color: tokens.color.semantic.text.linkHover,
      backgroundColor: tokens.color.semantic.bg.brandSubtlest,
    },
    "&:focus-visible": {
      outline: `2px solid ${tokens.color.semantic.border.focus}`,
      outlineOffset: "2px",
    },
    "&.active": {
      color: tokens.color.semantic.text.brand,
      backgroundColor: tokens.color.semantic.bg.brandSubtlest,
      "font-weight": tokens.font.weight.semibold,
    },
    "nav:hover &, nav:has(:focus-visible) &, nav:has([aria-expanded='true']) &": {
      width: "100%",
    },
  },
  navButtonText: {
    whiteSpace: "nowrap",
    opacity: 0,
    transition: "opacity 0.2s ease",
    "nav:hover &, nav:has(:focus-visible) &, nav:has([aria-expanded='true']) &": {
      opacity: 1,
    },
  },
}));

interface NavBarButtonProps {
  name: string;
  route: RoutePathsKeys;
  icon: IconV3Props["icon"];
}

export const NavBarButton: React.FC<NavBarButtonProps> = ({ name, route, icon }) => {
  const { classes } = useStyles();
  return (
    <NavRouteLink
      to={getRoutePath(route)}
      end={route === "home"}
      className={classes.navButton}
      aria-label={name}
      tabIndex={0}
    >
      <IconV3 icon={icon} size={24} color="currentColor" aria-hidden="true" />
      <span className={classes.navButtonText}>
        <RpiLabelText>{name}</RpiLabelText>
      </span>
    </NavRouteLink>
  );
};
